import React from "react";
import Menu from "../utils/Menu";
import { useAuthContext } from "../AuthProvider";
import { Link, useLocation } from "react-router-dom";

function Sidebar() {

    const { loginRole } = useAuthContext();

    const { pathname } = useLocation();

    const features = {
        'SUPER':[1,2,3,4,5], 
        'ADMIN':[4], 
        'MANAGEMENT':[1,2,3,4,5], 
        'TRADER':[1,2,3], 
        'RISK_MANAGER':[1,2,3,5]
    }

    const isActive = (menuPath) => pathname === menuPath || pathname.startsWith(`${menuPath}/`) ? 'active' : '';

    return (
        <nav className="navbar navbar-light navbar-vertical navbar-expand-xl">
            <div className="d-flex align-items-center">
                <div className="toggle-icon-wrapper">
                    <button className="btn navbar-togler-humburger-icon navbar-vertical-toggle" data-bs-toggle="tooltip" data-bs-placement="left" title="Toggle Navigation">
                        <span className="navbar-toggle-icon"><span className="toggle-line"></span></span>
                    </button>
                </div>
                <Link className="navbar-brand" to="/">
                    <div className="d-flex align-items-center py-3">
                        {/* <img className="me-2" src="assets/img/icons/spot-illustrations/cirrus.png" alt="" width="40" /> */}
                        <span className="font-sans-serif cirrus-color">SotPro</span>
                    </div>
                </Link>
            </div>
            <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
                <div className="navbar-vertical-content scrollbar">
                    <ul className="navbar-nav flex-column mb-3" id="navbarVerticalNav">

                        {Menu.map((menu, idx) => loginRole?.roleName && features[`${loginRole.roleName}`]?.includes(Number(menu.code)) &&
                            <li key={`sidebar_${idx}`} className="nav-item">
                                {(menu?.submenu.length > 0) ?
                                    <a className={`nav-link dropdown-indicator ${isActive(menu.path)}`}
                                        href={`#${menu.path}`} role="button"
                                        data-bs-toggle="collapse" aria-expanded="false"
                                        aria-controls={`${menu.path}`}
                                        onClick={(e) => e.preventDefault()}>
                                        <div className="d-flex align-items-center">
                                            <span className="nav-link-icon">
                                                <span className={`fas fa-${menu.icon}`}></span>
                                            </span>
                                            <span className="nav-link-text ps-1">{menu.title}</span>
                                        </div>
                                    </a> :
                                    <Link className={`nav-link ${isActive(menu.path)}`} to={menu.path}>
                                        <div className="d-flex align-items-center">
                                            <span className="nav-link-icon">
                                                <span className={`fas fa-${menu.icon}`}></span>
                                            </span>
                                            <span className="nav-link-text ps-1">{menu.title}</span>
                                        </div>
                                    </Link>}
                                {menu.submenu.length > 0 &&
                                    <ul className="nav collapse" id={`${menu.path}`}>
                                        {menu.submenu.map((submenu, sidx) =>
                                            <li key={`submenu_${sidx}`} className="nav-item"><Link className="nav-link" to={submenu.path}>
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text ps-1">{`${submenu.title}`}</span>
                                                </div>
                                            </Link></li>)}
                                    </ul>}
                            </li>)}
                    </ul>

                </div>
            </div>
        </nav>
    )
}

export default Sidebar;
